import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { enduserInterface } from 'src/app/util/interfaces/enduser';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class BehalfOfService {
	private behalfOfUrl = environment.baseApiUrl + 'behalfOf';

	headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	getAllowedBehalfOfUsers(userName: string, userEmail: string, idCustomer: string): Observable<enduserInterface[]> {
		if (userName == undefined) userName = '';
		if (userEmail == undefined) userEmail = '';
		if (idCustomer == undefined) idCustomer = '';
		return this.http
			.get(this.behalfOfUrl, { headers: this.headers, params: { customer: idCustomer, name: userName, email: userEmail } })
			.pipe(
				map((allowedBehalfOfUsersRes: any[]) => {
					const newUserArray: enduserInterface[] = [];
					for (const user of allowedBehalfOfUsersRes) {
						const newUser: enduserInterface = {
							fullName: user.full_name,
							email: user.email,
						};

						newUserArray.push(newUser);
					}

					return newUserArray;
				})
			);
	}

	enterBehalfOfMode(email: string): Observable<any> {
		return this.http.put(this.behalfOfUrl, {}, { headers: this.headers, params: { userEmail: email } });
	}

	leaveBehalfOfMode(): Observable<any> {
		return this.http.delete(this.behalfOfUrl, { headers: this.headers });
	}
}
